/**
 * Campo sobre la superficie clara de la tienda. `dark:bg-white` es
 * imprescindible: el primitive `Input` trae `dark:bg-input/30`, y bajo el tema
 * oscuro del cliente eso era el «campo negro» (spec 2026-09-23 §1).
 */
export const LIGHT_FIELD_CLASS =
  'h-11 border-stone-300 bg-white text-base text-stone-900 placeholder:text-stone-400 dark:bg-white focus-visible:border-red-600 focus-visible:ring-red-600/25'

export const LIGHT_HELP_CLASS = 'text-sm text-stone-600'
